import React from 'react'
import styles from './headerYellowSpecific.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PhoneNumberLink from '../../../../src/common/components/PhoneNumberLink/phonenumberlink'
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons'
import WhatsappIcon from './assets/whatsapp.svg'
import telephones from '../../constants/telephones'
import LanguageSelector from './LanguageSelector'

interface Props {
  esPath: string
  caPath: string
}

export default function HeaderYellowSpecific({ esPath, caPath }: Props) {
  return (
    <React.Fragment>
      <LanguageSelector esPath={esPath} caPath={caPath} />
      <div className={styles.phone}>
        <FontAwesomeIcon icon={faMobileAlt} className={styles.phone_icon} />
        <PhoneNumberLink telephone={telephones[0].telephone} />
      </div>
      <div className={styles.phone}>
        <WhatsappIcon className={styles.phone_iconWhatsapp} />
        <PhoneNumberLink
          countryCode={'34'}
          telephone={telephones[1].telephone}
        />
      </div>
    </React.Fragment>
  )
}
